import React from 'react';
import { useNavigate } from 'react-router-dom';
import { User } from '../types';

interface KycGateProps {
  user: User;
  children: React.ReactNode;
}

export const KycGate: React.FC<KycGateProps> = ({ user, children }) => {
  const navigate = useNavigate();
  const status = user.kyc?.status || 'not_submitted';

  if (status === 'approved') {
    return <>{children}</>;
  }

  const subtitle =
    status === 'submitted'
      ? 'Your KYC is under review. You will be able to access this section once it is approved.'
      : status === 'rejected'
      ? `Your KYC was rejected${user.kyc?.rejectReason ? `: ${user.kyc.rejectReason}` : ''}. Please resubmit.`
      : 'KYC is required to use this feature. Please submit your KYC details.';

  return (
    <div style={{
      minHeight: 'calc(100vh - 72px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px'
    }}>
      <div style={{
        background: '#ffffff',
        borderRadius: '16px',
        border: '1px solid #e5e7eb',
        padding: '24px',
        maxWidth: '480px',
        textAlign: 'center' as const
      }}>
        <div style={{ fontSize: '20px', fontWeight: 800, color: '#111827' }}>KYC Required</div>
        <div style={{ marginTop: '8px', color: '#6b7280', fontSize: '14px' }}>{subtitle}</div>
        <div style={{ marginTop: '16px' }}>
          <button
            onClick={() => navigate('/profile')}
            style={{
              padding: '12px 16px',
              background: 'linear-gradient(135deg, #ee4238, #af201c)',
              border: 'none',
              color: '#fff',
              borderRadius: '12px',
              fontWeight: 800
            }}
          >
            Go to Profile
          </button>
        </div>
      </div>
    </div>
  );
};


